import positionProperties from '../constants/position-properties';
import getPositionCustomProperties from './get-position-custom-properties';

const getRoundedValue = (value) => `${Math.round(value * 1000000) / 1000000}%`;
const setXProperty = (element, value) => {
  element.style.setProperty(positionProperties.X, getRoundedValue(value));
};
const setYProperty = (element, value) =>
  element.style.setProperty(positionProperties.Y, getRoundedValue(value));

const setPositionCustomProperties = (element, { x, y }) => {
  const { x: currentX, y: currentY } = getPositionCustomProperties(element);

  if (element.matches('ws-composite-item')) {
    element.setAttribute(
      'position',
      `${getRoundedValue(x !== undefined ? x : currentX)} ${getRoundedValue(
        y !== undefined ? y : currentY
      )}`
    );
    return;
  }

  if (x !== undefined && currentX !== x) {
    setXProperty(element, x);
  }

  if (y !== undefined && currentY !== y) {
    setYProperty(element, y);
  }
};

export default setPositionCustomProperties;
